import {roundDecimal} from 'shared/utils/number/roundDecimal';

export function percent(part: number, whole: number): Percentage {
  return roundDecimal((part / whole) * 100, 2);
}
